import React, { useState, useCallback } from "react";
import { Table, Pagination, Form } from "react-bootstrap";
import { FaChartBar } from "react-icons/fa";
import ExportXlsx from "../../../../../components/xlsx/ExportXlsx";
import DashMedidasSectionCard from "../../../../DashMedidas/components/DashMedidasSectionCard/DashMedidasSectionCard";

const DataTable = ({ user, data, handleChange, curvaSelecionada, allData, permissionSGU }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  }, []);

  const handleFilterGrain = (curva) => {
    const filteredData = curva ? allData.filter((i) => i.grain === curva) : allData;
    return filteredData;
  };

  const totalPages = Math.ceil(data.length / rowsPerPage);
  const paginatedData = data.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

  const getPaginationRange = () => {
    const start = Math.max(page - 2, 0);
    const end = Math.min(page + 2, totalPages - 1);
    let range = [];

    for (let i = start; i <= end; i++) {
      range.push(i);
    }
    return range;
  };

  const headerRight = data?.length ? (
    <span className="dash-section-card__header-meta">
      {data.length} curva{data.length !== 1 ? "s" : ""}
    </span>
  ) : null;

  return (
    <DashMedidasSectionCard
      icon={FaChartBar}
      subtitle="Curvas e"
      title="Médias"
      headerRight={headerRight}
      collapsible
      sectionId="relatorios-medias-curvas"
    >
      <div className="relatorios-table-wrap">
        <Table className="relatorios-curves-table" striped hover responsive size="sm">
          <thead>
            <tr>
              <th className="text-center">Curva</th>
              <th className="text-center">Umidade média</th>
              <th className="text-center">pH / Densidade média</th>
              <th className="text-center">Temperatura média</th>
              <th className="text-center">Nº de medidas</th>
              <th className="text-center">Relatórios</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((item) => (
              <tr
                key={item.grain || ""}
                onClick={() => handleChange(item.grain)}
                className={curvaSelecionada === item.grain ? "relatorios-curves-table__row--active" : ""}
                style={{ cursor: "pointer" }}
              >
                <td className="pt-2">{item.grain || "--"}</td>
                <td className="text-center pt-2">{item.humidity || "--"}</td>
                <td className="text-center pt-2">{item.ph || "--"}</td>
                <td className="text-center pt-2">{item.temperature || "--"}</td>
                <td className="text-center pt-2">{item.totalMeasures || "--"}</td>
                <td className="d-flex justify-content-center" onClick={(e) => e.stopPropagation()}>
                  <div style={{ width: 102 }}>
                    <ExportXlsx
                      user={user}
                      csvData={handleFilterGrain(item.grain || null)}
                      fileName={item.grain || "Relatório"}
                      size="sm"
                      permissionSGU={permissionSGU}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="relatorios-table-footer d-flex justify-content-between align-items-center flex-wrap gap-2">
          <Form.Group className="d-flex align-items-center gap-2 mb-0">
            <Form.Label className="mb-0 small text-secondary">Linhas por página</Form.Label>
            <Form.Select
              size="sm"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              style={{ width: "auto" }}
            >
              {[10, 20, 40].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Pagination className="mb-0 custom-pagination" size="sm">
            <Pagination.Prev
              onClick={() => handleChangePage(page - 1)}
              disabled={page === 0}
              aria-label="Página anterior"
            />
            {getPaginationRange().map((index) => (
              <Pagination.Item
                key={index}
                active={index === page}
                onClick={() => handleChangePage(index)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => handleChangePage(page + 1)}
              disabled={page >= totalPages - 1}
              aria-label="Próxima página"
            />
          </Pagination>
        </div>
      </div>
    </DashMedidasSectionCard>
  );
};

export default DataTable;
